import { AffiliationApiFactory } from 'generated';
import { instanceApi } from 'utils/axios';

const affiliationApi = AffiliationApiFactory(undefined, '', instanceApi);

export default affiliationApi;
